import Markdown from "./Markdown";
import { TbGalaxy, TbGhost, TbMicrophone } from "react-icons/tb";
import { CiGlobe } from "react-icons/ci";
import { BiPlus } from "react-icons/bi";

const OpeningChat = ({ chatId, fetchActions, actions, formatTimestamp, chatMessages, isSending, inputValue, newMexId, thinking, setInputValue, chatEndRef, handleSend, handleKeyDown, setLoadingActions, loadingActions, handleMicClick, microphoneOn, context }) => {


    const contextContent = {
        webapp: {
            title: "Bring your Full-stack Web App to life",
            desc: "Turn your ideas into a sleek, responsive, and fully functional web application with modern UI and a powerful custom backend."
        },
        serverless: {
            title: "Bring your Web App to life",
            desc: "Turn your ideas into a sleek, responsive, and fully functional web application with modern UI and a powerful managed backend."
        },
    };


    return (
        <div className="opening_chat_codespace">


            <div className="chat_container_ai_mex">
                {chatMessages.length === 0 && chatId == null ? (
                    <div className="opening_chat_codespace_chat">
                        <p className="opening_chat_codespace_chat_title fade-in">
                            {contextContent[context]?.title || "Let's build your next project"}
                        </p>
                        <p className="opening_chat_codespace_chat_desc fade-in">
                            {contextContent[context]?.desc || "Whether it’s a webapp, API, or pipeline — Erioon AI turns ideas into working software in minutes."}
                        </p>
                    </div>


                ) : (
                    <div className="opening_chat_codespace_chat">
                        <>
                            {chatMessages.map((msg, i) => (
                                <>
                                    <div
                                        key={i}
                                        className={
                                            msg.role === "assistant"
                                                ? "chat_message_ai_cont fade-in"
                                                : "chat_message_user_cont fade-in"
                                        }
                                    >
                                        <div
                                            className={
                                                msg.role === "assistant"
                                                    ? "chat_message_ai fade-in"
                                                    : "chat_message_user fade-in"
                                            }
                                        >
                                            {msg.role === "assistant" ? (
                                                <>
                                                    {msg.content ? (
                                                        <Markdown msg={msg} newMexId={newMexId} chatEndRef={chatEndRef} />

                                                    ) : (
                                                        i === chatMessages.length - 1 && (

                                                            thinking && (
                                                                <div className="thinking_message">

                                                                    <div className="thinking_message_header">
                                                                        <i className="logo_rotating">
                                                                            <TbGalaxy />
                                                                        </i>
                                                                        <p className="thinking_message_p fade-in">Thinking</p>

                                                                    </div>

                                                                </div>
                                                            )
                                                        )

                                                    )}


                                                    <div className="chat_timestamp">
                                                        {formatTimestamp(msg.timestamp)}
                                                        {/* {(i === chatMessages.length - 1 && msg.role === "assistant" && msg.content) && (
                                                            <button
                                                                className="live_actions_btn"
                                                                onClick={() => {
                                                                    setLoadingActions(true);
                                                                    fetchActions();
                                                                    setTimeout(() => setLoadingActions(false), 2000);
                                                                }}
                                                            >
                                                                <i className={`fa-solid fa-rotate ${loadingActions ? "loading_notification" : ""}`}></i> Live actions
                                                            </button>

                                                        )} */}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="user_msg">
                                                        {msg.content}
                                                    </div>
                                                    <div className="chat_timestamp">
                                                        {formatTimestamp(msg.timestamp)}
                                                    </div>
                                                </>
                                            )}


                                        </div>
                                    </div>
                                    {i === chatMessages.length - 1 && actions.length > 0 && (
                                        <div className="actions_container_ai_main">

                                            <div className="actions_container_ai">
                                                <p className="actions_container_ai_title">Live actions</p>
                                                {actions.map((actionText, i) => {
                                                    return (
                                                        <div className="single_action_card fade-in"
                                                            dangerouslySetInnerHTML={{ __html: actionText }}></div>
                                                    );
                                                })}

                                            </div>
                                        </div>
                                    )}
                                    <div ref={chatEndRef}></div>
                                </>

                            ))}
                        </>
                    </div>

                )}

                <div />
            </div>
            <div className="opening_chat_codespace_chat_footer fade-in">
                <div className="opening_chat_codespace_chat_footer_inner">

                    <div className="input_chat_ai_container">
                        <div className="input_chat_ai_container_top">
                            <textarea
                                className="input_chat_ai"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                onKeyDown={handleKeyDown}
                                disabled={isSending}
                                placeholder="Type your message..."
                                style={{ resize: "none", overflowY: "auto" }}
                            />
                        </div>
                        <div className="bottom_ai_chat_items">
                            <div className="bottom_ai_chat_items_btns_cont">
                                {/* <button className="bottom_ai_chat_items_btn"><BiPlus /></button> */}
                                {/* <button className="bottom_ai_chat_items_btn"><CiGlobe /></button> */}
                                <button className={`bottom_ai_chat_items_btn ${microphoneOn ? "bottom_ai_chat_items_btn_selected" : ""}`} onClick={handleMicClick}><TbMicrophone /></button>
                            </div>


                            <div className="button_chat_ai_container">
                                <button
                                    className="button_chat_ai"
                                    onClick={handleSend}
                                    disabled={isSending}
                                >
                                    <i className="fa-solid fa-arrow-up"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="ai_warning_chat_cont">
                        <p>
                            Erioon AI may generate inaccurate or incomplete information.
                            Please verify important details.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default OpeningChat